<div
  :id="isMobile ? 'offcanvasExample' : null"
  :class="isMobile ? 'offcanvas offcanvas-start d-lg-none' : ['client-sidebar', 'admin-sidebar', { close: isClosed }]"
  :tabindex="isMobile ? '-1' : null"
  :aria-labelledby="isMobile ? 'offcanvasExampleLabel' : null"
  class="sidebar-shell"
>
  <div v-if="isMobile" class="offcanvas-header p-3">
    <button
      type="button"
      class="btn-close text-reset ms-auto"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>

  <div
    :class="[
      'client-sidebar',
      'admin-sidebar',
      'd-flex',
      'flex-column',
      'justify-content-between',
      'bg-white',
      'position-relative',
      isMobile ? 'offcanvas-body p-0' : '',
      { close: isClosed, 'min-vh-100 mt-2 rounded-end': !isMobile, 'h-100 w-100 mt-2': isMobile }
    ]"
  >
  <button v-if="!isMobile && !isClosed" class="btn btn-link text-dark position-absolute top-0 end-0 mb-2 p-0" @click="isClosed = true" aria-label="Close sidebar">
    <i class="bi bi-list fs-6"></i>
  </button>

  <button v-else-if="!isMobile" class="btn btn-link text-dark position-absolute top-0 end-0 mt-2 p-0" @click="isClosed = false" aria-label="Open sidebar">
    <i class="bi bi-chevron-double-right fs-6"></i>
  </button>
<div>
  <div class="flex-grow-1 overflow-auto scrollarea min-h-0">
      
      <li class="nav-item my-0 mt-2 w-100">
        <router-link to="/dashboard" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Dashboard' : ''">
          <i class="bi bi-grid-fill fs-6"></i>
          <div class="text-xxs fw-bold" v-if="!isClosed">Dashboard</div>
        </router-link>
      </li>

      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
    <div v-if="client_features.show_portals">

      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        
        <span v-if="school_domain">Grades Management</span>
          <span v-else>Portal Management</span>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/create_portal" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? (!cbo_domain ? 'Manage Portals' : 'Manage Membership') : ''">
          <i class="bx bx-command fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">
            <span v-if="school_domain">Manage Grades</span>
            <span v-else-if="cbo_domain">Manage Chapters</span>
            <span v-else>Manage Portals</span></div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/create_report" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Reports' : ''">
          <i class="bi bi-journal-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Feeds</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100" v-if="!cbo_domain">
        <router-link to="/create_group" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Groups' : ''">
          <i class="bi bi-people fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">
            <span v-if="school_domain">Manage Classes</span>
            <span v-else>Manage Groups</span>
          </div>
        </router-link>
      </li>
      
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
    </div>

    <div>
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        User Management
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/create_user" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Users' : ''">
          <i class="bi bi-person-badge fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Users</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/view_business_dashboard" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Business Profiles' : ''">
          <i class="bi bi-briefcase fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Business Profiles</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100" v-if="!workbook_domain && !dwypd_domain">
        <router-link to="/create_membership" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Membership' : ''">
          <i class="bi bi-chat-square-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Membership</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
    </div>


    <div v-if="client_features.show_events">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        Events Management
      </li>
      <li class="nav-item my-0 w-100">
        <router-link to="/events" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Events' : ''">
          <i class="bi bi-calendar2-event fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Events</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_rsvps" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Events' : ''">
          <i class="bi bi-calendar2-event fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage RSVPs</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100" v-if="!workbook_domain && !dwypd_domain">
        <router-link to="/create_membership" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Membership' : ''">
          <i class="bi bi-chat-square-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Membership</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
    </div>

    <div v-if="client_features.show_marketplace">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        Marketplace Management
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_catalogue" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Catalogue' : ''">
          <i class="bi bi-graph-up fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Products</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100">
        <router-link to="/manage_services" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Services' : ''">
          <i class="bi bi-graph-up fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Services</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100">
        <router-link to="/manage_promotions" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Promotions' : ''">
          <i class="bi bi-graph-up fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Promotions</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />

    </div>


<div>

      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold text-small" v-if="!isClosed">
        Form Management
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/create_form" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Forms' : ''">
          <i class="bi bi-file-earmark-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Forms</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_sections" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Sections' : ''">
          <i class="bi bi-list-task fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Sections</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_questions" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Questions' : ''">
          <i class="bi bi-question-square fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Questions</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100">
        <router-link to="/create_profile_tabs" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Profile Tabs' : ''">
          <i class="bi bi-file-earmark-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Profile Tabs</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />

</div>

<div>
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        Community Management
      </li>


      <li class="nav-item my-0 w-100">
        <router-link to="/create_assets" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Assets' : ''">
          <i class="bi bi-graph-up fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Assets</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100 d-none">
        <a href="/create_survey" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" :title="isClosed ? 'Manage Surveys' : ''">
          <i class="bi bi-clipboard-check fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Surveys & Polls</div>
        </a>
      </li>

      <li class="nav-item my-0 w-100 d-none">
        <a href="/create_discussion" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" :title="isClosed ? 'Manage Surveys' : ''">
          <i class="bi bi-chat-left-text small"></i>
          <div class="text-xxs" v-if="!isClosed">Discussions</div>
        </a>
      </li>
</div>

 <div class="d-flex justify-content-start mt-auto p-3">
  <div 
    @click="log_out" 
    class="d-flex align-items-center gap-2 pointer-link logout-item pointer"
  >
    <i class='bx bx-log-out-circle fs-4'></i>
    <span class="fw-bold text-xxs">Logout</span>
  </div>
</div>
  </div>

</div>
</div>
</div>
